import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Abouthouston() {
  return (
    <section className="about_houston p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Houston Mobile App Development Is All About The TekRevolution
            </h2>
            <p>
              Tekrevol’s efforts in Houston revolve mainly around our mission of
              creating lasting impact. We just recently launched our mobile
              application in Houston called “The Veteran App,” which aims to
              help our veterans reintegrate into society, post-military service.
            </p>
            <p>
              Working with an ex-veteran, “The Veteran App” aims to provide our
              veteran community with the opportunity to find focus groups for
              PTSD therapy sessions, group counseling, finding other veterans to
              make personal connections, and finding job opportunities to
              revitalize and derive new meaning in life outside of their
              service. With our technological expertise, our goal is to help
              people in Houston and everywhere else in the world in making their
              life better, and utilizing our top-notch technology and services
              for creating an ever-lasting impact.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Lets Connect
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <StaticImage
              src="../../images/location_new/houston/houston_about.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={787}
              height={738}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Abouthouston;
